import queryString from 'query-string';

export function mainStateToUrlParams({ businessIdea, industry, tags, purpose, businessDetails }, debugApp) {
  const objQuery = { debugApp, businessIdea };
  if (industry && industry.industryText) {
    const { industry: industryValue, isCustom, industryText } = industry;
    objQuery.industry = JSON.stringify({ industry: industryValue, isCustom, industryText });
  }

  if (Array.isArray(tags) && tags.length) {
    objQuery.tags = tags.join('|');
  }

  if (Array.isArray(purpose.purpose) && purpose.purpose.length) {
    objQuery.purpose = purpose.purpose.join('|');
  }

  if (businessDetails && businessDetails.companyDetails) {
    const { companyDetails, industry: bIndustry } = businessDetails;
    const { companyName, tagLine } = companyDetails;

    objQuery.bcm = companyName;
    if (tagLine) {
      objQuery.btl = tagLine;
    }

    if (industry) {
      objQuery.bi = bIndustry.industry;
      objQuery.bc = bIndustry.isCustom;
      objQuery.bt = bIndustry.industryText;
    }
  }

  return queryString.stringify(objQuery);
}
